export default "__VITE_ASSET__Dvabs3sJ__"